export const manageInitialState = { 
    users: undefined,
    error: undefined
}

export function manageReducer(state, action) {
    switch (action.type) {
        case 'FETCH':
            return { users: action.users, error: undefined }
        case 'CREATE':
            return {...state, 
                users: [...state.users, action.user], 
                error: undefined
            }
        case 'EDIT': 
            return {...state, 
                users: state.users.map(u => u.user === action.user.user ? { ...u, ...action.user } : u),
                error: undefined
            }
        case 'DELETE':
            return {...state, 
                users: state.users.filter(u => u.user !== action.name), 
                error: undefined
            }
        case 'ERROR':
            return {...state, error: action.error}
        default:
            return {...state}
    }
}
